export const FUND_BANK_ACCOUNT = 'fund_bank_account';
export const ORDER_PHYSICAL_DEBIT_CARD = 'order_physical_debit_card';
export const ACTIVATE_NEW_DEBIT_CARD = 'activate_new_debit_card';
export const SETUP_DEBIT_CARD_PIN = 'setup_debit_card_pin';
export const ADD_VIRTUAL_CARD_TO_WALLET = 'add_virtual_card_to_wallet';
export const STRIPE_ACCOUNT_LEARN_MORE = 'stripe_account_learn_more';
export const SETUP_PAYMENTS = 'set_up_payments';
export const STRIPE_ACCOUNT_PENDING = 'stripe_account_pending';
export const STRIPE_ACCOUNT_OPENED = 'stripe_account_opened';
export const STRIPE_ACCOUNT_GET_PAID = 'stripe_account_get_paid';
export const COMPLETED_NEXT_UP_CARD = 'completed_all_next_up_cards';

// Mutation
export const ADDED_VIRTUAL_CARD_TO_WALLET = 'added_virtual_card_to_wallet';
export const DISMISSED_ORDER_PHYSICAL_DEBIT_CARD = 'dismissed_order_physical_debit_card';
